import { render, staticRenderFns } from "./Master-medicine.vue?vue&type=template&id=707bc197&scoped=true"
import script from "./Master-medicine.js?vue&type=script&lang=js&external"
export * from "./Master-medicine.js?vue&type=script&lang=js&external"
import style0 from "./Master-medicine.vue?vue&type=style&index=0&id=707bc197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bc197",
  null
  
)

export default component.exports